import * as Yup from 'yup';

const EmailSchema = Yup.object().shape({
  Email: Yup.string()
    .email('Invalid email')
    .required('Email field is required!')
});

export default EmailSchema;
